import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

/**
 * Core fields are fields that are guaranteed to be present in all extBATs.
 */
export const coreFields = {
  month: {
    displayName: msg({
      message: 'Month',
      context: 'The display name for the month field',
    }),
    externalDescription: msg({
      message: 'The month the business activity took place.',
      context: 'Month',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
